<template>
    <div>
        <div :class="classes">
            <router-view />
        </div>
        <g-row type="flex" justify="space-around" class="g-pb-6">
            <powered-by-grin style="text-align: center" />
        </g-row>
    </div>
</template>

<script>
    import get from 'lodash/get';
    import set from 'lodash/set'
    import { message } from '@grininc/grin-ui';
    import NavigationMenu from './NavigationMenu.vue';
    import PoweredByGrin from '../../../app-v2/components/library/PoweredByGrin.vue';
    import useFeatureFlagsStore from '../../../stores/feature-flags';
    import { computed } from 'vue-demi';

    export default {
        /**
         * The component name
         *
         * @type {string}
         */
        name: 'Dashboard',
        components: {
            NavigationMenu,
            PoweredByGrin
        },
        created() {
            const freshLogin = get(this.$root.v2, 'freshLogin', '');

            if (freshLogin === 'success') {
                message.success('Account verified.', 5);
            } else if (freshLogin === 'expired') {
                message.error('Login link expired.', 5);
            } else if (freshLogin === 'error') {
                message.error('Verification could not be completed. Please try again or contact support.', 5);
            }

            // @see: https://grin.atlassian.net/browse/EX-400
            set(window, 'SERVER_DATA.fresh_login', '');
        },
        setup(props, context) {
            const FeatureFlag = useFeatureFlagsStore().data;
            const showTabs = computed(() => context.root.$route.name !== 'edit.profile');
            const widenPageContainer = computed(() => {
                return (
                    (FeatureFlag['live-site-responsive-dashboard'] || false) &&
                    (FeatureFlag['live-site-responsive-design'] || false) &&
                    context.root.$route.name === 'sponsorships'
                );
            });

            const classes = computed(() => {
                return {
                    container: true,
                    'g-pb-6': true,
                    'container__no-tabs': !showTabs.value,
                    'wide-container': widenPageContainer.value
                };
            });

            return {
                FeatureFlag,
                classes
            };
        }
    };
</script>

<style lang="scss" scoped>
    .wide-container {
        max-width: 960px;
    }
</style>
